import { useMemo } from 'react';
import { SuggestionData } from '../types';

export const useTextSuggestion = (searchTerm: string): SuggestionData[] =>
  useMemo(
    () => [{ type: 'TextSuggestion', filters: { text: searchTerm }, id: `text-${searchTerm}` }],
    [searchTerm],
  );
